<template>
  <div class="sign-up pop-up">
    <div class="sign-up__inner">
      <div class="sign-up__content">
        <div class="sign-up__logo-text-box">
          <a class="sign-up__logo" :href="isNativeIOSApp ? '#' : '/'">
            <img
              class="sign-up__logo-img"
              src="@/assets.v2/images/logo-sign-up.svg"
              alt="Shortform"
            />
          </a>
        </div>
      </div>
      <div class="sign-up__form-box">
        <div v-if="view.state === 'form'" class="shortform-sign-up">
          <h2 class="shortform-sign-up__title">Reset Password</h2>
          <p class="shortform-sign-up__p">
            Enter your email below and we'll send you a link to reset your
            password.
          </p>
          <form
            role="form"
            class="shortform-sign-up__form"
            novalidate
            @submit.prevent="submitForm"
          >
            <div class="shortform-sign-up__group">
              <label class="shortform-sign-up__label" for="register_email"
                >Email Address</label
              >
              <InputWithContextMenu
                id="email"
                v-model="view.model.email"
                class="shortform-sign-up__input"
                placeholder=""
                type="email"
                autocomplete="username"
                autofocus
                :class="view.validation.stateClass('email')"
              />
              <FormError :errors="view.validation.errors" field="email" />
              <router-link
                :to="{ name: 'login', query: $route.query }"
                class="shortform-sign-up__forgot-password"
                ><strong>Back to Login</strong></router-link
              >
            </div>
            <div class="shortform-sign-up__group">
              <vWait for="Submit">
                <template v-slot:waiting>
                  <span class="shortform-sign-up__submit button button--theme">
                    Processing...
                    <button-spinner />
                  </span>
                </template>
                <button
                  type="submit"
                  class="shortform-sign-up__submit button button--theme"
                >
                  Send reset link
                </button>
              </vWait>
            </div>
          </form>
        </div>
        <div v-if="view.state === 'success'" class="shortform-sign-up">
          <p>
            We've sent you an email, follow the instructions to reset your
            password.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useWait } from '../composables/useWait'

import { PasswordForgotView } from '@/models/auth/models'
import { authCssFix } from '@/helpers/html'
import { platform } from '@/services/platform'
import { waitTimer } from '@/helpers/timer'

import FormError from '@/components/ui/FormError.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import vWait from 'vue-wait/src/components/v-wait.vue'

const wait = useWait()

const view = ref(new PasswordForgotView())
const isNativeIOSApp = ref(false)

onMounted(async () => {
  isNativeIOSApp.value = await platform.isNativeIOSApp()
  authCssFix()
})

async function submitForm(): Promise<void> {
  wait.start('Submit')
  try {
    // Wait for submit to complete plus up to two seconds delay
    // to prevent fast clicking issues.
    await Promise.all([view.value.submitForm(), waitTimer(2000)])
  } finally {
    wait.end('Submit')
  }
}
</script>
